import { headTraumaChecks } from "../Config/lookups.js";
import { callEntryTypes } from "../Config/lookups.js";

export const hitBopOptions = [
  {
    id: "headTraumaCheck-NotDiscussed",
    value: headTraumaChecks.NOT_DISCUSSED,
    label: "Not Discussed",
  },
  {
    id: "headTraumaCheck-DiscussedInPreviousCalls",
    value: headTraumaChecks.DISCUSSED_IN_PREVIOUS_CALLS,
    label: "Discussed In Previous Call(s)",
  },
  {
    id: "headTraumaCheck-NoneReported",
    value: headTraumaChecks.NONE_REPORTED,
    label: "Discussed But None Reported",
  },
  {
    id: "headTraumaCheck-DiscussedButUnknown",
    value: headTraumaChecks.DISCUSSED_BUT_UNKNOWN,
    label: "Discussed But Unknown",
  },
  {
    id: "headTraumaCheck-Reported",
    value: headTraumaChecks.REPORTED,
    label: "Reported",
  },
];

/**
 * Filters the list of call entry types to include only the allowed types.
 * Not all types are allowed, because some of them are just used for historical purposes.
 *
 * @type {Array<Object>}
 */
export const allowedCallEntryTypes = callEntryTypes.filter(
(callEntrytype) => ['lawEnforcement', 'nonLawEnforcement', 'thirdPartyCaller', 'vettingCall', 'non800LineContact'].includes(callEntrytype.value));
